import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { getCorporations } from "../../../services/accountService";

export type Corporation = {
  accountHolderId: string;
  corpName: string;
};

export default function useCorporationsQuery(
  merchantAccountId: string,
  queryOptions?: UseQueryOptions<Corporation[], string>
) {
  return useQuery<Corporation[], string>(
    ["corporations", merchantAccountId],
    () => getCorporations(merchantAccountId),
    {
      staleTime: 5 * 60 * 1000,
      enabled: Boolean(merchantAccountId),
      ...queryOptions,
    }
  );
}
